export const TaskDistributionTable = ({ data, SumedTotalHours }) => {
  return data && data.length > 0 ? (
    <div className=" p-6 mx-auto border">
      <h2 className="text-3xl font-bold text-center mb-6">Task Distribution</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300 bg-white shadow-md rounded-lg overflow-hidden">
          <thead className="bg-gray-800 text-white">
            <tr>
              <th className="px-6 py-3 text-left">Task</th>
              <th className="px-6 py-3 text-right">Hours</th>
              <th className="px-6 py-3 text-right">% Hours</th>
            </tr>
          </thead>
          <tbody className="">
            {data.map(([task, hours], index) => (
              <tr key={index} className="border-b hover:bg-gray-100">
                <td className="px-6 py-3">{task}</td>
                <td className="px-6 py-3 text-right font-semibold">{hours}</td>
                <td className="px-6 py-3 text-right font-semibold">
                  {((hours * 100) / SumedTotalHours).toFixed(2)}%
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  ) : (
    <div></div>
  );
};
